var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 4.16659C10.1988 4.16659 8.33333 6.03206 8.33333 8.33325C8.33333 10.6344 10.1988 12.4999 12.5 12.4999C14.8011 12.4999 16.6667 10.6344 16.6667 8.33325C16.6667 6.03206 14.8011 4.16659 12.5 4.16659ZM6.25 8.33325C6.25 4.88147 9.04822 2.08325 12.5 2.08325C15.9518 2.08325 18.75 4.88147 18.75 8.33325C18.75 11.785 15.9518 14.5833 12.5 14.5833C9.04822 14.5833 6.25 11.785 6.25 8.33325ZM6.05536 17.3088C7.75357 16.2473 10.0348 15.6249 12.5 15.6249C14.9652 15.6249 17.2465 16.2473 18.9447 17.3088C20.6281 18.361 21.875 19.9479 21.875 21.8749C21.875 22.4502 21.4086 22.9166 20.8333 22.9166C20.258 22.9166 19.7917 22.4502 19.7917 21.8749C19.7917 20.9254 19.173 19.9083 17.8405 19.0754C16.5226 18.2518 14.6372 17.7083 12.5 17.7083C10.3628 17.7083 8.47739 18.2518 7.15952 19.0754C5.82699 19.9083 5.20833 20.9254 5.20833 21.8749C5.20833 22.4502 4.74196 22.9166 4.16667 22.9166C3.59137 22.9166 3.125 22.4502 3.125 21.8749C3.125 19.9479 4.37182 18.361 6.05536 17.3088Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.bae396ebaecd38b420afc0f1bd72385b.svg";
export { ForwardRef as ReactComponent };